import { useContext } from 'react';
import AuthContext from '../contexts/JWTAuthContext';

const useAuthContext = () => useContext(AuthContext);

export default useAuthContext;